import {
  AfterViewChecked,
  Component,
  ElementRef,
  ViewChild,
  Input,
} from '@angular/core';
import EventModel from '../../../models/event';
import { environment } from '../../../../../environments/environment';
import { DashboardService } from '../../../../features/events/services/dashboard.service';
import { Router } from '@angular/router';

interface HeaderItem {
  label: string;
  slug?: string;
  href?: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements AfterViewChecked {
  @Input() mode: 'default' | 'transparent' = 'default';
  @ViewChild('searchInput') searchInput!: ElementRef;

  public items: HeaderItem[] = [];

  showSearch = false;
  searchCriteria = '';
  showNav = false;

  public events: EventModel[] = [];
  private _events(): EventModel[] {
    return this.dashboardService._events;
  }

  get searchIconName() {
    let iconName = 'search';

    if (this.showSearch) iconName = 'close';

    return iconName;
  }

  get logoSrc(): string {
    return this.mode === 'transparent'
      ? 'assets/img/tix-white.png'
      : 'assets/img/logo-tix.png';
  }

  constructor(
    private router: Router,
    private dashboardService: DashboardService
  ) {
    this.items = [
      { label: 'Eventos', slug: 'events/all' },
      { label: 'Precios', slug: 'precios' },
      { label: 'Publicar Evento', href: `${environment.vendorsUrl}/register` },
      { label: 'Contacto', slug: 'contacto' },
    ];
  }

  ngAfterViewChecked(): void {
    if (this.showSearch) this.searchInput.nativeElement.focus();
  }

  toggleSearch() {
    if (this.showNav) this.toggleNav();

    this.showSearch = !this.showSearch;
  }

  toggleNav() {
    if (this.showSearch) this.toggleSearch();

    this.showNav = !this.showNav;

    // document.getElementsByTagName('body')[0].classList.toggle('overflow-hidden')
  }

  onSearchEvent($event: Event) {
    const target = $event.target as HTMLInputElement;
    const q = target.value.trim() ?? '';
    const events = this._events();

    if (!q) {
      this.events = events;
      return;
    }

    this.events = events.filter((e) => {
      return e.name.toLowerCase().trim().includes(q.toLowerCase().trim());
    });
  }

  closeSearch() {
    this.searchCriteria = '';
    this.showSearch = false;
  }

  protected readonly environment = environment;

  goTo(item: HeaderItem) {
    if (item.slug) {
      this.router.navigate([item.slug]);
    } else if (item.href) {
      window.location.href = item.href;
    }

    this.showNav = false;
  }

  goToHome() {
    this.router.navigate(['/']);
  }
}
